import {Component, Input, ViewChild} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {EnrollmentRentalPropertyModel} from "../../domain/models/enrollment-rental-property.model";
import {EnrollmentComponent} from "../enrollment-request/EnrollmentComponent";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {MatSelectModule} from "@angular/material/select";
import {RentalPropertyInfoComponent} from "../rental-property-info/rental-property-info.component";

@Component({
  selector: 'app-mgmt-company-rental-property',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    ReactiveFormsModule,
    RentalPropertyInfoComponent
  ],
  templateUrl: './mgmt-company-rental-property.component.html',
  styleUrl: './mgmt-company-rental-property.component.css'
})
export class MgmtCompanyRentalPropertyComponent implements EnrollmentComponent {
  @Input() property!: EnrollmentRentalPropertyModel;
  @ViewChild(RentalPropertyInfoComponent) rentalProperty!: RentalPropertyInfoComponent;

  constructor() {
  }

  getUpdatedEnrollment(): EnrollmentModel {
    return this.rentalProperty.getUpdatedEnrollment();
  }

  isFormValid(): boolean {
    return this.rentalProperty.isFormValid();
  }

  raiseFormValidations(): void {
    return this.rentalProperty.raiseFormValidations();
  }
}
